<template>
    <div class="form-modal-wrapper">
        <TitleBaseBox :title="data.title" @close="cancelForm" @confirm="confirmForm">
            <FromRender
                class="form-content"
                :formData="formValue"
                :comps="comps"
                :verifyInfo="verifyInfo"
                :rules="rules"
                :validation="myValidation"
                @change="formChange"
                @verify="verifyHandler"
            />
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox.vue";
import FromRender from "./FormRender.vue";
import Validation from "./validation.js";

export default {
    name: "FormModal",
    components: { FromRender, TitleBaseBox },
    props: ["data"],
    data() {
        return {
            formValue: this.data.formData,
            comps: this.data.comps,
            rules: this.data.rules || {},
            verifyInfo: {},
            loading: false,
            myValidation: null
        };
    },
    created() {
        this.myValidation = new Validation();
        this.validation && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        formChange(newValue) {
            this.formValue = newValue;
        },
        verifyHandler(info) {
            this.verifyInfo = info;
        },
        async confirmForm() {
            if (!this.data.confirm) {
                return;
            }

            // 校验输入是否符合要求
            const { isValid } = await this.myValidation.validate();
            if (!isValid) {
                return;
            }
            this.loading = true;
            // confirm需要返回一个promise函数，只有当promise函数的执行结果为成功时，才会关闭页面
            const retPromise = this.data.confirm(this.formValue);
            if (retPromise) {
                retPromise
                    .then(() => {
                        this.$emit("closeModal");
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
                this.$emit("closeModal");
            }
        },
        cancelForm() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.form-modal-wrapper {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .el-input .el-input__clear {
        line-height: 32px;
    }
}
.form-content {
    width: 600px;
}
</style>
